import { render, staticRenderFns } from "./TaskTimeSpents.vue?vue&type=template&id=22b14312&"
import script from "./TaskTimeSpents.vue?vue&type=script&lang=js&"
export * from "./TaskTimeSpents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports